"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriangleDown = TriangleDown;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function TriangleDown({
  color,
  size = 1,
  variant
}) {
  if (variant === 'solid') {
    return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
      heightAndWidth: size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M17 8H7a1.001 1.001 0 00-.815 1.581l5 7a1.002 1.002 0 001.629 0l5-7a.999.999 0 00.074-1.038A.995.995 0 0017 8z",
      fillColor: color
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M11.186 16.581a1.002 1.002 0 001.628 0l5-7a.999.999 0 00.074-1.038A.995.995 0 0017 8H7a.999.999 0 00-.814 1.581l5 7zM15.057 10L12 14.279 8.943 10h6.114z",
    fillColor: color
  }));
}